
async function hashPassword(password) {
    try {
        const hashedPassword = password;
        return hashedPassword;
    } catch (error) {
        console.error('Error al hash la contraseña:', error);
        throw new Error('Error al hash la contraseña');
    }
}

export { hashPassword };
